<template src='./time-to-project-implementation.html'></template>

<script>
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'
import Vue from 'vue'
import HighlightButton from '@/components/misc/HighlightButton.vue'
import moment from 'moment'
import { EventBus } from '@/router/bus'

export default {
  components: {
    Tabulator,
    HighlightButton
  },
  mixins: [tabulatorMixin],
  props: ['data', 'project', 'selectedPhase', 'projectCode', 'projectPhaseId'],
  data () {
    return {
      indicator: {},
      displayResetButton: false,
      tabulatorOptions: {
        ajaxSorting: false,
        ajaxFiltering: false,
        pagination: false,
        paginationSize: undefined,
        ajaxURLGenerator: undefined,
        headerSortElement: '',
        footerElement: '',
        layout: 'fitColumns',
        columns: [
          {
            title: 'Г',
            field: 'year',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Година',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 50
          },
          {
            title: 'К',
            field: 'quarter',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Квартал',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 50
          },
          {
            title: 'ДИ',
            field: 'quarterEndDate',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Дан најскоријег Извештаја (Об. 6)',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + moment(cell.getValue(), 'YYYY-MM-DD').format('DD.MM.YYYY') + '</b>' : '<b>' + this.$t('general.undefined') + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'ДП',
            field: 'projectStartDate',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Дан почетка реализације КП (Obrazac 5, Tačka 1.2)',
            formatter: (cell, formatterParams, onRendered) => {
              var row = cell.getRow()
              var rowPosition = row.getPosition(true)
              if (rowPosition) {
                return cell.getValue() ? '<b>' + moment(cell.getValue(), 'YYYY-MM-DD').format('DD.MM.YYYY') + '</b>' : '<b>' + this.$t('general.undefined') + '</b>'
              } else {
                return cell.getValue() ? moment(cell.getValue(), 'YYYY-MM-DD').format('DD.MM.YYYY') : this.$t('general.undefined')
              }
            },
            minWidth: 100,
            cssClass: 'bold-text'
            // editor: this.dateEditor
          },
          {
            title: 'ДИ - ДП',
            field: 'implementationDays',
            hozAlign: 'right',
            headerHozAlign: 'right',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 110
          },
          {
            title: 'УР',
            field: 'activityQuarterAmount',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Укупни расходи КП по кварталу (Об. 6, Tačka 4.2)',
            formatter: 'money',
            cssClass: 'bold-text',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
            // editor: 'number',
            // editorParams: {
            //   min: 0,
            //   max: 999999999999999,
            //   step: 1000,
            //   elementAttributes: {
            //     maxlength: '20'
            //   }
            // }
          },
          {
            title: 'ИВ УТ',
            field: 'activityTotalAmount',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Измењена вредност укупних трошкова КП (Об. 6, Tačka 3.1). Уколико се ова вредност није изменила, користи се вредност из претходног Обрасца (периода)',
            formatter: 'money',
            cssClass: 'bold-text',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
            // editor: 'number',
            // editorParams: {
            //   min: 0,
            //   max: 999999999999999,
            //   step: 1000,
            //   elementAttributes: {
            //     maxlength: '20'
            //   }
            // }
          },
          {
            title: 'ВДР Н',
            field: 'value',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'ВДР према Извештају о напретку реализације',
            formatter: (cell, formatterParams, onRendered) => {
              if (cell.getValue() < 0) {
                return '<b>(' + (-cell.getValue()) + ')</b>'
              }
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'УР',
            field: 'activityQuarterInitialAmount',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Укупни расходи КП по кварталу (Об. 5, Tačka 4.2)',
            formatter: 'money',
            cssClass: 'bold-text',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
            // editor: 'number',
            // editorParams: {
            //   min: 0,
            //   max: 999999999999999,
            //   step: 1000,
            //   elementAttributes: {
            //     maxlength: '20'
            //   }
            // }
          },
          {
            title: 'ПВ УТ',
            field: 'activityTotalInitialAmount',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Процењена вредност УТ КП (Об. 5, Tačka 3.4)',
            formatter: (cell, formatterParams, onRendered) => {
              var row = cell.getRow()
              var rowPosition = row.getPosition(true)
              if (rowPosition) {
                return '<b>' + this.formatPrice(cell.getValue()) + '</b>'
              } else {
                return this.formatPrice(cell.getValue())
              }
            },
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150,
            editor: this.numberEditor,
            editorParams: {
              min: 0,
              max: 999999999999999,
              step: 1000,
              elementAttributes: {
                maxlength: '20'
              }
            }
          },
          {
            title: 'ВДР П',
            field: 'initialValue',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'ВДР према Плану реализације',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'ГВ ВДР',
            field: 'limitReached',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'ГРАНИЧНА ВРЕДНОСТ ВДР',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.limitReached') + '</b>' : '<b>' + this.$t('successKeyIndicator.ok')
            },
            minWidth: 150
          }
        ]
      }
    }
  },
  computed: {
    getColor () {
      return this.project.phase === this.selectedPhase.phase ? 'var(--v-cards-base)' : 'var(--v-success-light-base)'
    }
  },
  methods: {
    calculate () {
      this.showLoader(true)
      this.$http.post(Vue.$apiConfig.calculateSuccessKeyIndicatorPost, { timeToProjectImplementation: this.data })
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            this.reloadData(payload.timeToProjectImplementation)
            this.displayResetButton = true
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    reset () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.successKeyIndicatorGet.replace('{projectCode}', this.projectCode).replace('{projectPhaseId}', this.projectPhaseId))
        .then(
          response => {
            this.logConsole(response)
            this.reloadData(response.data.payload.map(x => x.timeToProjectImplementation))
            this.displayResetButton = false
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    reloadData (data) {
      EventBus.$emit('reloadTimeToProjectImplementationData', data)
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    dateEditor (cell, onRendered, success, cancel) {
      var row = cell.getRow()
      var rowPosition = row.getPosition(true)
      if (rowPosition > 0) return false
      // cell - the cell component for the editable cell
      // onRendered - function to call when the editor has been rendered
      // success - function to call to pass thesuccessfully updated value to Tabulator
      // cancel - function to call to abort the edit and return to a normal cell
      // create and style input
      var cellValue = moment(cell.getValue(), 'YYYY-MM-DD').format('YYYY-MM-DD')
      var input = document.createElement('input')

      input.setAttribute('type', 'date')

      input.style.padding = '4px'
      input.style.width = '100%'
      input.style.boxSizing = 'border-box'

      input.value = cellValue

      onRendered(function () {
        input.focus()
        input.style.height = '100%'
      })

      function onChange () {
        if (input.value !== cellValue) {
          var test = moment(input.value, 'YYYY-MM-DD').format('YYYY-MM-DD')
          success(test)
        } else {
          cancel()
        }
      }

      // submit new value on blur or change
      input.addEventListener('blur', onChange)

      // submit new value on enter
      input.addEventListener('keydown', function (e) {
        if (e.keyCode === 13) {
          onChange()
        }

        if (e.keyCode === 27) {
          cancel()
        }
      })

      return input
    },
    numberEditor (cell, onRendered, success, cancel) {
      var row = cell.getRow()
      var rowPosition = row.getPosition(true)
      if (rowPosition > 0) return false

      var cellValue = cell.getValue()
      var input = document.createElement('input')

      input.setAttribute('type', 'number')

      input.style.padding = '4px'
      input.style.width = '100%'
      input.style.boxSizing = 'border-box'

      input.value = cellValue

      onRendered(function () {
        input.focus()
        input.style.height = '100%'
      })

      function onChange () {
        if (input.value !== cellValue) {
          success(input.value)
        } else {
          cancel()
        }
      }

      // submit new value on blur or change
      input.addEventListener('blur', onChange)

      // submit new value on enter
      input.addEventListener('keydown', function (e) {
        if (e.keyCode === 13) {
          onChange()
        }

        if (e.keyCode === 27) {
          cancel()
        }
      })

      return input
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>
<style>
  .tabulator .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {
    padding-right: 0px !important;
  }
</style>
